/* eslint-env browser, jquery */
(function() {
    window.App.onReady(function() {
        $('.price-counter').each(function() {
            var $button = $(this).find('.in-basket');
            var $counter = $(this).find('.catalog--counter__count');
            $(this).find('.catalog--counter__minus').on('click', function() {
                var value = $counter.html() - 0;

                value--;
                if (value <= 0) {
                    value = 1;
                }

                $counter.html(value);
                $button.data('count', value);

                return false;
            }).end().find('.catalog--counter__plus').on('click', function() {
                var value = $counter.html() - 0;

                value++;
                if (value >= 1000) {
                    value = 999;
                }

                $counter.html(value);
                $button.data('count', value);

                return false;
            });

            $button.on('click', function() {
                var $this = $(this);
                if ($this.attr('disabled')) {
                    return false;
                }
                $this.attr('disabled', 'disabled');
                $.ajax({
                    url: '/users/inbasket/',
                    dataType: 'json',
                    type: 'post',
                    data: {
                        catalog_id: $this.data('id'),
                        count: $this.data('count')
                    },
                    cache: false,
                    success: function(res) {
                        $this.removeAttr('disabled');
                        if (res.success == 1) {
                            $('.basket-head').show();
                            $('[change_auto_count=true]').html(res.count);
                            $('[change_auto_summ=true]').html(res.summ);
                        } else {
                            alert(res.message);
                        }
                    }
                });
                return false;
            });
        });
    });
})();
